export const isVideo = (filename: string) => {
  return (
    filename.toLowerCase().endsWith('.mpg') ||
    filename.toLowerCase().endsWith('.mpeg') ||
    filename.toLowerCase().endsWith('.ogg') ||
    filename.toLowerCase().endsWith('.mp4') ||
    filename.toLowerCase().endsWith('.webm') ||
    filename.toLowerCase().endsWith('.avi') ||
    filename.toLowerCase().endsWith('.3gp') ||
    filename.toLowerCase().endsWith('.mov')
  );
};
